export const PROPERTIES_INSIGHTS: {
  pageType: string;
} = {
  pageType: 'privateClientSite',
};
